import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["disableWhenDirty"];
  static values = { dirtyTitle: { type: String, default: "Save changes first" } };

  connect() {
    this.dirty = false;
    this.boundPreventClick = this.preventClick.bind(this);
  }

  markDirty() {
    if (this.dirty) return;
    this.dirty = true;
    this.disableWhenDirtyTargets.forEach((el) => {
      el.classList.add("disabled");
      el.setAttribute("title", this.dirtyTitleValue);
      el.addEventListener("click", this.boundPreventClick);
    });
  }

  markClean() {
    this.dirty = false;
    this.disableWhenDirtyTargets.forEach((el) => {
      el.classList.remove("disabled");
      el.removeAttribute("title");
      el.removeEventListener("click", this.boundPreventClick);
    });
  }

  preventClick(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}
